import { PublicContentPage, publicPageHeading } from '../../features/public/PublicContentPage';
import { PublicCta } from '../../features/public/PublicCta';
import { seoForPath } from '../../features/public/seoConfig';

const BENEFITS = [
  {
    title: 'Join organized group rides',
    body: 'Accept invites from riding groups and see meeting points, timing, and ride details in one place.',
  },
  {
    title: 'Stay aligned on the road',
    body: 'Follow the captain, check in at stops, and know who is riding with you without endless chat threads.',
  },
  {
    title: 'Build your rider profile',
    body: 'Add your motorcycle and riding preferences so groups know who is joining and what bike you ride.',
  },
  {
    title: 'Discover riding communities',
    body: 'Connect with fellow motorcycle riders and find groups that match your riding style — from local clubs to touring crews.',
  },
] as const;

export function ForRidersPage() {
  return (
    <PublicContentPage seo={seoForPath('/for-riders')}>
      {publicPageHeading(
        'A motorcycle riding app for individual riders',
        'Whether you ride solo on weekends or join club runs, RideMaadi helps you find riding groups and participate in organized motorcycle rides.',
      )}
      <section aria-labelledby="rider-benefits">
        <h2 id="rider-benefits" className="sr-only">
          Benefits for individual riders
        </h2>
        <ul className="space-y-4">
          {BENEFITS.map(({ title, body }) => (
            <li
              key={title}
              className="rounded-2xl bg-surface p-5 shadow-sm shadow-black/[0.04] dark:shadow-black/20"
            >
              <h2 className="text-base font-semibold">{title}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-muted">{body}</p>
            </li>
          ))}
        </ul>
      </section>
      <section className="mt-10 space-y-3" aria-labelledby="rider-who">
        <h2 id="rider-who" className="text-lg font-semibold">
          Who is this for?
        </h2>
        <p className="text-sm leading-relaxed text-muted sm:text-base">
          RideMaadi is for motorcycle riders who want to join group rides with a clear plan — new
          riders looking for a community, experienced riders joining club runs, and anyone tired of
          coordinating rides through chat apps.
        </p>
      </section>
      <div className="mt-12">
        <PublicCta heading="Join your next group ride on RideMaadi" />
      </div>
    </PublicContentPage>
  );
}
